import { useQuery } from '@tanstack/react-query'

import { MIN_SEARCH_LENGTH, TABLE_PAGE_SIZE } from '@/utils/constants'

import { globalSearchApi } from './services'

const GLOBAL_SEARCH_QUERY_KEY = (params: (string | number)[]) => [
  'global-search',
  ...(params ? [params] : []),
]

export const useGlobalSearch = (params: {
  search?: string
  rowsPerPage?: number
}) => {
  const { search = '', rowsPerPage = TABLE_PAGE_SIZE } = params
  const query = search.trim().length >= MIN_SEARCH_LENGTH ? search.trim() : ''

  return useQuery({
    queryKey: GLOBAL_SEARCH_QUERY_KEY([query, rowsPerPage]),
    queryFn: async () => {
      const response = await globalSearchApi.getGlobalSearch({
        q: query,
        limit: rowsPerPage,
      })

      return response.data?.[0]
    },
    enabled: !!query,
  })
}
